import KYCForm from './KYCForm';

export default KYCForm;
